import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import { config } from './config.js';
import { initGA, setPageViewGA } from './utils/ga.js';
import { initMix } from './utils/mixpanel.js';
import Layout from './components/layout/Layout.js';
import Login from './pages/Login.js';
import Contact from './pages/Contact.js';
import Setting from './pages/setting/index.js';
import PaymentBenefit from './pages/paymentBenefit/index.js';
import PaymentDebit from './pages/paymentDebit/index.js';
import PaymentPremium from './pages/paymentPremium/index.js';
import PolicyLoan from './pages/policyLoan/index.js';
import Policy from './pages/policy/index.js';
import Claim from './pages/claim/index.jsx';
import ChangeContact from './pages/changeContact/index.js';
import HospitalNetwork from './pages/hospitalNetwork/index.js';
import Investment from './pages/investment/index.js';
import Documents from './pages/documents/index.js';
import SuggestProduct from './pages/suggestProduct/index.js';
import GroupEB from './pages/groupEB/index.jsx';
import NotFound from './pages/NotFound.js';
import Privilege from './pages/privilege/index.js';
import IndexLevelTableRoute from './pages/indexLevelTable/index.js';
import MaintenencePage from './pages/MaintenencePage.js';
import SearchPartner from './pages/searchPartner/index.js';
import TaxConsent from './pages/taxConsent/index.js';
import LONImmigration from './pages/lonImmigration.js';
import PRUServiceSSO from './pages/pruserviceSSO/index.jsx';

import './style/main.scss';

import dayjs from 'dayjs';
import 'dayjs/locale/th';
import MaintenenceHook from './components/layout/MaintenenceHook.js';
// import CheckCMSNewVersionLayer from './components/layout/CheckCMSNewVersionLayer';
import DigitalPayment from './pages/digitalPayment/index.js';
import { SurveyProvider } from './providers/survey.provider.jsx';
import AutoDirectDebitRoute from './pages/autoDirectDebit/index.jsx';
import BigRewardCampaignRoute from './pages/bigRewardCampaign/index.jsx';

dayjs.locale('th');

if (config.mode === 'prd') console.log = function no_console() {};

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    setPageViewGA();
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Layout currentPage={location.pathname}>
      <Routes>
        <Route path="/" element={<NotFound />} />
        <Route path="/login" element={<Login />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/setting/*" element={<Setting />} />
        <Route path="/Mypolicy/*" element={<Policy />} />
        <Route path="/eclaim/*" element={<Claim />} />
        <Route path="/policy-loan/*" element={<PolicyLoan />} />
        <Route path="/payment-premium/*" element={<PaymentPremium />} />
        <Route path="/payout-benefit/*" element={<PaymentBenefit />} />
        <Route
          path="/payment-directdebit/*"
          element={<AutoDirectDebitRoute />}
        />
        {/* <Route path="/payment-directdebit/*" element={<PaymentDebit />} /> */}
        <Route path="/change-contact/*" element={<ChangeContact />} />
        <Route path="/hospital-network" element={<HospitalNetwork />} />
        <Route path="/investment" element={<Investment />} />
        <Route path="/suggest-product" element={<SuggestProduct />} />
        <Route path="/groupEB" element={<GroupEB />} />
        <Route path="/privilege/*" element={<Privilege />} />
        <Route path="/index-level-table/*" element={<IndexLevelTableRoute />} />
        <Route path="/maintenence" element={<MaintenencePage />} />
        <Route path="/search-partner/*" element={<SearchPartner />} />
        <Route path="/tax-consent/*" element={<TaxConsent />} />
        <Route path="/documents-download/*" element={<Documents />} />
        <Route path="/lon-immigration" element={<LONImmigration />} />
        <Route path="/ps-sso/*" element={<PRUServiceSSO />} />
        <Route path="/digital-payment/*" element={<DigitalPayment />} />
        <Route
          path="/big-reward-campaign/*"
          element={<BigRewardCampaignRoute />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  useEffect(() => {
    initGA(config.ga);
    initMix(config.mix);
  }, []);

  return (
    <BrowserRouter>
      <MaintenenceHook>
        {/* <CheckCMSNewVersionLayer> */}
        <SurveyProvider>
          <AppContent />
        </SurveyProvider>
        {/* </CheckCMSNewVersionLayer> */}
      </MaintenenceHook>
    </BrowserRouter>
  );
}
